<div class="mat-elevation-z1">
  <div class="filter" [ngClass]="{ 'sticky-filter-header': stickyFilterHeader }">
    @if (filterMode === 'quick') {
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <mat-form-field class="no-wrapper" appearance="fill" fxFlex subscriptSizing="dynamic">
          <input
            matInput
            [(ngModel)]="filter"
            title="Filter"
            type="search"
            placeholder="Filter"
            (keyup)="applyFilter(filter)"
          />
          <mat-icon class="filter-icon" matPrefix>filter_alt</mat-icon>
          @if (filter) {
            <button mat-icon-button matSuffix type="button" (click)="clearFilter()">
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
        <span fxLayoutGap="10px">
          @for (action of tableActions; track action; let i = $index) {
            <button
              mat-stroked-button
              type="button"
              [disabled]="
                action.canDisable
                  ? checkBoxStatus === checkedStatus.NONE || showSpinner
                  : showSpinner
              "
              (click)="tableClickAction(action.type, i)"
            >
              @if (showSpinner && actionIndex === i) {
                <mat-icon>
                  <mat-spinner diameter="18"></mat-spinner>
                </mat-icon>
              }
              {{ action.label }}
            </button>
          }
        </span>
      </div>
    }
    @if (filterMode === 'actions' && tableActions?.length) {
      <div class="filter-actions-only" fxLayout="row" fxLayoutAlign="end center">
        <span fxLayoutGap="10px">
          @for (action of tableActions; track action; let i = $index) {
            <button
              mat-stroked-button
              type="button"
              [disabled]="
                action.canDisable
                  ? checkBoxStatus === checkedStatus.NONE || showSpinner
                  : showSpinner
              "
              (click)="tableClickAction(action.type, i)"
            >
              @if (showSpinner && actionIndex === i) {
                <mat-icon>
                  <mat-spinner diameter="18"></mat-spinner>
                </mat-icon>
              }
              {{ action.label }}
            </button>
          }
        </span>
      </div>
    }
  </div>
  <mat-divider></mat-divider>
  <table mat-table [dataSource]="dataSource" matSort>
    @for (column of displayedColumns; track column) {
      <ng-container [matColumnDef]="column.value">
        @if (column.value === checkbox) {
          <th class="column-header" mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              [checked]="checkBoxStatus === checkedStatus.ALL"
              [indeterminate]="checkBoxStatus === checkedStatus.PARTIAL"
              (change)="toggleAllRowsSelected()"
            ></mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox
              [(ngModel)]="row.selected"
              (change)="checkIndeterminateStatus()"
              (click)="$event.stopPropagation()"
            ></mat-checkbox>
          </td>
        }
        @if (column.value === actions) {
          <th
            mat-header-cell
            *matHeaderCellDef
            class="actions-cell"
            style="text-align: right"
            [ngClass]="filterMode === 'column' ? 'column-header-filter' : 'column-header'"
          >
            <ng-content select="[actionButton]"></ng-content>
            @if (displayFilterColumns) {
              <ag-table-column-panel
                [placeholder]="'Filter Column'"
                [tableGridColumns]="displayedColumns"
                (columnsChanged)="columnsChanged.emit($event)"
              ></ag-table-column-panel>
            }
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="actions-cell"
            style="text-align: right; white-space: nowrap"
          >
            <ng-container
              [ngTemplateOutlet]="rowActionIcons"
              [ngTemplateOutletContext]="{
                $implicit: {
                  data: row
                }
              }"
            ></ng-container>
            <!-- Content projection row actions -->
            @if (rowActions) {
              <button
                mat-icon-button
                type="button"
                aria-label="More options"
                matTooltip="More"
                [matMenuTriggerFor]="menu"
                [disabled]="showSpinner"
                (click)="$event.stopPropagation()"
              >
                <mat-icon>more_vert</mat-icon>
              </button>
              <!-- Row actions -->
              <mat-menu #menu="matMenu">
                @for (action of rowActions; track action) {
                  <button mat-menu-item type="button" (click)="rowActionSelect(action.type, row)">
                    {{ action.label }}
                  </button>
                }
              </mat-menu>
            }
          </td>
        } @else {
          <th
            [hidden]="!column.display"
            [ngClass]="filterMode === 'column' ? 'column-header-filter' : 'column-header'"
            mat-header-cell
            *matHeaderCellDef
            style="white-space: nowrap"
          >
            <div>
              @if (sortable) {
                <span [mat-sort-header]="column.value">{{ column.label }}</span>
              } @else {
                <span>{{ column.label }}</span>
              }
              <div>
                @if (filterMode === 'column') {
                  <mat-form-field floatLabel="auto">
                    <input
                      matInput
                      [(ngModel)]="columnFilterValues[column.value]"
                      (keyup)="onColumnKeyup($event, column.value)"
                    />
                    @if (columnFilterValues[column.value]) {
                      <button
                        mat-icon-button
                        matSuffix
                        type="button"
                        (click)="clearColumnFilter(column.value)"
                      >
                        <mat-icon>close</mat-icon>
                      </button>
                    }
                  </mat-form-field>
                }
              </div>
            </div>
          </th>
          <ng-container *matCellDef="let row">
            @if (column.value !== actions) {
              <td
                mat-cell
                [hidden]="!column.display"
                [matTooltip]="column.tooltip ? column.tooltip(row[column.value]) : null"
                [innerHTML]="row | cellDisplayFn: column | cellConvertArray | highlight: filter"
                [ngClass]="{ 'text-link': column.clickFn }"
                (click)="column.clickFn ? column.clickFn(row) : null"
              ></td>
            }
          </ng-container>
        }
      </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="columns; sticky: stickyColumnHeader"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: columns"
      (click)="toggleRow(row)"
      [ngClass]="{ highlight: row.selected, pointer: multiSelect || rowSelection }"
    ></tr>
    <tr class="mat-row" *matNoDataRow>
      <td style="text-align: center" class="mat-cell" [attr.colspan]="columns.length">
        {{ noDataMessage }}
      </td>
    </tr>
  </table>
  @if (showPagination) {
    <mat-paginator
      [ngClass]="{ 'mat-paginator-sticky': stickyFooter }"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="pageSizeOptions"
      [length]="length"
      (page)="onPageEvent($event)"
      showFirstLastButtons
    ></mat-paginator>
  }
</div>
